module.exports = __webpack_public_path__ + "media/recipes/1-60bd1ce3.png";